let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2iY1i")).then(() => parcelRequire('a9Gyo'));